import React, { useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getPets } from "../../../api/petService";

const PetAutocomplete = ({
  value,
  onChange,
  label = "Select Pet",
  ...props
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = async (event, inputValue, reason) => {
    if (reason === "input") {
      if (inputValue.length >= 2) {
        setLoading(true);
        try {
          const response = await getPets(1, 10, inputValue);
          setItems(response?.data || []);
        } catch (error) {
          console.error("Error fetching pets:", error);
        } finally {
          setLoading(false);
        }
      } else {
        // Clear items if input is less than 2 characters
        setItems([]);
      }
    }
  };

  const handleChange = (event, newValue) => {
    if (!newValue) {
      // User clicked clear (x) → clear options too
      setItems([]);
    }
    onChange?.(newValue ? newValue.id : "");
  };

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) =>
        `${option.name} (${option.owner.last_name}, ${option.owner.first_name})` || ""
      }
      value={items.find((item) => item.id === value) || null}
      onChange={handleChange}
      onInputChange={handleInputChange}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default PetAutocomplete;
